/**
=========================================================
* Otis Admin PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from 'react';

// react-router-dom components
import { useLocation } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// Otis Admin PRO React components
import MDBox from '../MDBox';

// Otis Admin PRO React context
import { useMaterialUIController, setLayout } from 'context';
import BillzLoadingIndicator from 'components/BillzLoadingIndicator/billzLoadingIndicator';

function DashboardLayout({ isLoading = false, children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;

  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'dashboard');
  }, [pathname]);

  function getPreloadingChildren() {
    return children.filter === undefined ? (
      <React.Fragment />
    ) : (
      children.filter((child) => child && child.props.preloading === true)
    );
  }

  function getNonPreloadingChildren() {
    return children.filter === undefined
      ? getNonPreloadedChild(children)
      : children.filter((child) => child && child.props.preloading !== true);
  }

  function getNonPreloadedChild(child) {
    return child.props.preloading !== true ? child : <React.Fragment />;
  }

  function renderNonPreloadedComponents() {
    return (
      <React.Fragment>
        {isLoading === true ? <BillzLoadingIndicator /> : <React.Fragment />}
        {getNonPreloadingChildren()}
      </React.Fragment>
    );
  }

  function renderPreloadedComponents() {
    return isLoading === true ? <React.Fragment /> : getPreloadingChildren();
  }

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        position: 'relative',

        [breakpoints.up('xl')]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(['margin-left', 'margin-right'], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {renderNonPreloadedComponents()}
      {renderPreloadedComponents()}
    </MDBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
};

export default DashboardLayout;
